import React from 'react'

import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'

import HFQuantitiesGroup from 'components/HFInputs/HFQuantitiesGroup'
import styles from '../Dialog.module.sass'
import { TaskNeedsController } from 'controllers/TaskManager/TaskSubControllers/TaskNeedsController/TaskNeedsController'
import TaskMedicalActsController from 'controllers/TaskManager/TaskSubControllers/TaskMedicalActsController/TaskMedicalActsController'
import TaskIntervenientsController from 'controllers/TaskManager/TaskSubControllers/TaskIntervenientsController/TaskIntervenientsController'
import ExpandableWidget from 'components/ExpandableWidget/ExpandableWidget'
import HFTextInput from 'components/HFInputs/HFTextInput'
import HFOptionGroup from 'components/HFInputs/HFOptionGroup'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import InfoList from 'components/InfoList/InfoList'

export const SurgeryClinicalApprovalForm = (props) => {
	const { i18n } = useGlobal()
	const { data } = props
	const { requisitionDetails, requisition, isFromIsland } = data

	const urgencyOptions = [
		{
			value: '1',
			text: i18n`Normal`,
			description: i18n`Surgery can wait`,
		},
		{
			value: '2',
			text: i18n`Urgent`,
			description: i18n`Surgery soon`,
		},
		{
			value: '3',
			text: i18n`Emergent`,
			description: i18n`Immediate surgery`,
		},
	]

	return (
		<>
			<TaskMedicalActsController requisition={requisition} />

			{requisition?.medicalActs && requisition?.medicalActs.length > 0 ? (
				<fieldset>
					<HStack gap='xsmall'>
						<h4>{i18n`Surgeries`}</h4>
						<h4 className={styles['counter']}>
							{requisition?.medicalActs?.length || 0}
						</h4>
					</HStack>
					<HFQuantitiesGroup
						name={'surgeries'}
						data={requisition?.medicalActs || []}
					/>
				</fieldset>
			) : null}

			<fieldset>
				<h4>{i18n`Urgency`}</h4>
				<HFOptionGroup
					className={styles['option-group']}
					name='urgency'
					layout='horizontal'
					options={urgencyOptions}
				/>
			</fieldset>

			<fieldset>
				<VStack>
					<h4>{i18n`Surgery data`}</h4>
					<InfoList
						items={requisitionDetails}
						orientation={'vertical'}
					/>
				</VStack>
			</fieldset>

			<TaskIntervenientsController requisition={requisition} />

			{isFromIsland && (
				<TaskNeedsController
					isAdministrative={false}
					requisition={requisition}
				/>
			)}

			<fieldset className={styles['observation-container']}>
				<ExpandableWidget
					className={styles['observation']}
					heading='h5'
					title={i18n`Clinical Observations`}
				>
					<HFTextInput
						name='medicalObservation'
						placeholder={i18n`Clinical observation (optional)`}
						multiline={true}
						rows={5}
						noResize
					/>
				</ExpandableWidget>
			</fieldset>
		</>
	)
}
